import type { TableViewSort } from "@/entities/table-view";
import type { ListTableColumnKey } from "@/modules/list-table";

export const filterSortKeys = (
  sortKeys?: TableViewSort,
  columnsKeys?: ListTableColumnKey[]
): TableViewSort => {
  if (!sortKeys || !columnsKeys) return [];

  const filterKeys = columnsKeys.map((column) => column.sortKey);

  return sortKeys.filter((sortKey) =>
    filterKeys.includes(sortKey.replace("-", ""))
  );
};
